import { makeStyles, Paper } from "@material-ui/core";
import withLayout from "components/HoC/withLayout";
import FromA from "components/smart-visa-extension/FromA";
import PartA from "components/smart-visa-extension/PartA";
import PartB from "components/smart-visa-extension/PartB";
import PartC from "components/smart-visa-extension/PartC";
import PartD from "components/smart-visa-extension/PartD";
import PartE from "components/smart-visa-extension/PartE";
import PartF from "components/smart-visa-extension/PartF";
import PartG from "components/smart-visa-extension/PartG";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "0 10px",
  },
  label: {
    alignItems: "flex-start",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
}));

function ExtensionStep() {
  const step = 0;

  switch (step) {
    case 0:
      return <PartA />;
    case 1:
      return <PartB />;
    case 2:
      return <PartC />;
    case 3:
      return <PartD />;
    case 4:
      return <PartE />;
    case 5:
      return <PartF />;
    case 6:
      return <PartG />;
    case 7:
      return <FromA />;
    default:
      return null;
  }
}

function ExtensionPage() {
  const classes = useStyles();

  return (
    <Paper className={classes.paper}>
      <ExtensionStep />
    </Paper>
  );
}

export default withLayout(ExtensionPage);
